import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { CompanyListsActionsComponent } from './company-lists.actions.component';
import { CompanyListsService }          from './company-lists.service';
import { ConfirmService }               from '../messages/confirm/confirm.service';
import { MessagesService }              from '../messages/messages.service';
import { RemoveComponent }              from '../table/cell-components/actions/remove.component';
import { Table }                        from '../table/types/table';
import { TemplateModel }                from '../templates/typings/template';

@Component({
  selector   : 'wor-company-lists-templates',
  template: require('./company-lists.templates.component.html')
})
export class CompanyListsTemplatesComponent {
  @Input() templates: Array<TemplateModel> = [];
  @Input() title    : string;
  @Input() type     : string;

  collapsed = false;

  tableSettings : Table = {
    columns: [
      {
        component: {
          bindings: {
            outputs: {
              onRemoveClick: ( template : TemplateModel ) => this.deleteTemplate(template)
            }
          },
          enabled: true,
          factory: RemoveComponent,
        },
        sortable: false
      },
      {
        field : 'description',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: ( template : TemplateModel ) => this.editTemplate(template)
            }
          },
          enabled: true,
          factory: CompanyListsActionsComponent,
        },
        sortable: false
      }
    ],
    empty: {
      text: this.translateService.instant('INSPECTIONS_SPACE.TEMPLATES.NO_TEMPLATES_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    }
  };

  constructor (
    private companyListsService: CompanyListsService,
    private confirmService     : ConfirmService,
    private messagesService    : MessagesService,
    private translateService   : TranslateService
  ) {}

  addTemplate () : void {
    this.companyListsService.addTemplate({
      wording     : '',
      wording_type: this.type
    })
    .then(( template : TemplateModel ) => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.TEMPLATE'), 'success');

      this.templates = [ ...this.templates, template ];
    })
    .catch(error => this.messagesService.error(error));
  }

  deleteTemplate ( template : TemplateModel ) : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_TEMPLATE'))
    .then(() => this.companyListsService.deleteTemplate(template))
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.TEMPLATE'), 'success');

      this.templates = this.templates.filter(currentTemplate => currentTemplate.id !== template.id);
    })
    .catch(error => this.messagesService.error(error));
  }

  editTemplate ( template : TemplateModel ) : void {
    this.companyListsService.addTemplate({ ...template })
    .then(( updatedTemplate : TemplateModel ) => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.TEMPLATE'), 'success');

      this.templates = this.templates.map(currentTemplate => currentTemplate.id === template.id
        ? updatedTemplate
        : currentTemplate
      );
    })
    .catch(error => this.messagesService.error(error));
  }

  refreshTable () : void {
    this.templates = this.templates.map(template => ({ ...template }));
  }
}
